import conditionsCommon from "./reusable/conditionsCommon";

/**
 * Mixin used for handling 'Update field' conditions.
 * For now, they only update checkboxes based on set of conditions.
 */
export default {
  props: ['updateConditions'],
  mixins: [conditionsCommon],
  methods: {
    renderAllUpdateConditions() {
      if (this.updateConditions != null) {

        this.updateConditions.forEach(obj => {
          if (obj.todo) {
            // if there is no primaryState cond specified set it to true
            const isPrimaryStateCondTrue = obj.primaryState ? this.getStateForCondition(obj.primaryState) : true;

            // render actions if "ALL" is TRUE and every condition met, or ALL is FALSE and at least one condition is met
            let shouldSelect;
            if (obj.all === 'true') {
              shouldSelect = obj.states.every(e => this.getStateForCondition(e)) && isPrimaryStateCondTrue;
            } else {
              shouldSelect = obj.states.some(e => this.getStateForCondition(e) && isPrimaryStateCondTrue)
            }

            // update all fields
            obj.todo.forEach((todo) => {
              this.formData[todo.field] = shouldSelect ? this.fieldByName[todo.field].label : null;
            })
          }
        });
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/formRender/updateCheckboxConditions.js